import { createTriggerStore } from "@utils/createTriggerStore";
import { UsersAndGroupsTriggerPayload } from "./types";

const store = createTriggerStore<UsersAndGroupsTriggerPayload>();

export const openUsersAndGroupsModal = store.open;
export const closeUsersAndGroupsModal = store.close;
export const useUsersAndGroupsTrigger = store.useTrigger;
